import React, { useState, useEffect, useRef } from 'react';
import { supabase } from '../../lib/supabase';
import * as LuIcons from 'react-icons/lu';
import SafeIcon from '../../common/SafeIcon';
import { ADMIN_CONFIG } from '../../config/adminConfig';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const { LuSettings, LuSave, LuRefreshCw, LuCheck, LuLock, LuLayoutTemplate, LuFootprints, LuEye, LuImage, LuUpload, LuX, LuGlobe, LuHeart, LuScaling, LuEyeOff, LuShieldCheck, LuUsers, LuFileText, LuType } = LuIcons;

const BUCKET = 'images';

const DEFAULT_VALUES = {
  calc_title: 'حاسبة الجمركة',
  calc_subtitle: 'الرجاء اختيار الماركة والموديل لمعرفة تكلفة جمركة السيارات المستوردة.',
  cars_title: 'السيارات المقترحة',
  cars_subtitle: 'أحدث العروض المتوفرة للبيع.',
  navbar_site_name: 'كارد زاير',
  navbar_site_tagline: 'سيارات + جمركة',
  navbar_home_label: 'الرئيسية',
  navbar_bg_color: '#ffffff',
  navbar_accent_color: '#10b981',
  navbar_logo_url: '',
  navbar_logo_size: '40',
  site_favicon_url: '',
  footer_site_name: 'كارد زاير',
  footer_tagline: 'صُنع بـ ❤️ في الجزائر',
  footer_copyright: `© ${new Date().getFullYear()} جميع الحقوق محفوظة`,
  footer_bg_color: '#ffffff',
  footer_text_color: '#64748b',
  affiliate_reg_open: 'true',
  affiliate_terms: '',
  affiliate_reg_title: 'إنشاء حساب مسوق',
  affiliate_reg_subtitle: 'أدخل بياناتك لإنشاء حسابك والبدء في التسويق',
  page_about_us: '',
  page_contact_us: '',
};

const SUBTABS = [
  { id: 'general', label: 'النصوص العامة', icon: LuSettings },
  { id: 'navbar', label: 'شريط التنقل', icon: LuLayoutTemplate },
  { id: 'footer', label: 'الفوتر', icon: LuFootprints },
  { id: 'pages', label: 'الصفحات الإضافية', icon: LuFileText },
  { id: 'affiliate', label: 'التسويق بالعمولة', icon: LuUsers },
  { id: 'password', label: 'كلمة المرور', icon: LuLock },
];

const inputCls = "w-full p-3 border border-slate-200 rounded-xl focus:ring-2 focus:ring-emerald-500 outline-none bg-white text-sm";

// إعدادات محرر النصوص
const quillModules = {
  toolbar: [
    [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
    [{ 'color': [] }, { 'background': [] }],
    [{ 'align': [] }],
    ['bold', 'italic', 'underline', 'strike'],
    [{ 'list': 'ordered'}, { 'list': 'bullet' }, { 'direction': 'rtl' }],
    ['link', 'image', 'video'],
    ['clean']
  ],
};

const quillFormats = [
  'header', 'color', 'background', 'align',
  'bold', 'italic', 'underline', 'strike',
  'list', 'bullet', 'direction',
  'link', 'image', 'video'
];

const AdminPasswordChange = () => {
  const [currentPass, setCurrentPass] = useState('');
  const [newPass, setNewPass] = useState('');
  const [confirmPass, setConfirmPass] = useState('');
  const [showCurrent, setShowCurrent] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');
    setSuccess(false);
    if (currentPass !== ADMIN_CONFIG.adminPassword) { setError('كلمة المرور الحالية غير صحيحة.'); return; }
    if (newPass.length < 6) { setError('كلمة المرور الجديدة يجب أن تكون 6 أحرف على الأقل.'); return; }
    if (newPass !== confirmPass) { setError('كلمة المرور الجديدة وتأكيدها غير متطابقتين.'); return; }
    ADMIN_CONFIG.adminPassword = newPass;
    setSuccess(true);
    setCurrentPass(''); setNewPass(''); setConfirmPass('');
    setTimeout(() => setSuccess(false), 4000);
  };

  return (
    <div className="max-w-md">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 bg-amber-100 rounded-xl flex items-center justify-center"><SafeIcon icon={LuLock} className="w-5 h-5 text-amber-600" /></div>
        <div>
          <h2 className="text-lg font-bold text-slate-800">تغيير كلمة المرور</h2>
          <p className="text-xs text-slate-500">تغيير كلمة مرور لوحة الإدارة</p>
        </div>
      </div>
      <div className="bg-amber-50 border border-amber-200 rounded-xl p-3 mb-5 flex items-start gap-2">
        <SafeIcon icon={LuShieldCheck} className="w-4 h-4 text-amber-600 flex-shrink-0 mt-0.5" />
        <p className="text-xs text-amber-700">التغيير مؤقت لهذه الجلسة فقط. لتغيير دائم، عدّل قيمة <code className="bg-amber-100 px-1 rounded">adminPassword</code> في ملف <code className="bg-amber-100 px-1 rounded">src/config/adminConfig.js</code></p>
      </div>
      <form onSubmit={handleSubmit} className="space-y-4">
        {[
          { label: 'كلمة المرور الحالية', val: currentPass, set: setCurrentPass, show: showCurrent, toggle: () => setShowCurrent(p => !p) },
          { label: 'كلمة المرور الجديدة', val: newPass, set: setNewPass, show: showNew, toggle: () => setShowNew(p => !p) },
          { label: 'تأكيد كلمة المرور الجديدة', val: confirmPass, set: setConfirmPass, show: showConfirm, toggle: () => setShowConfirm(p => !p) },
        ].map((field, i) => (
          <div key={i}>
            <label className="block text-sm font-bold text-slate-700 mb-1">{field.label}</label>
            <div className="relative">
              <input type={field.show ? 'text' : 'password'} value={field.val} onChange={e => field.set(e.target.value)} required dir="ltr" className={inputCls + ' pe-10'} placeholder="••••••••" />
              <button type="button" onClick={field.toggle} className="absolute inset-y-0 left-0 ps-3 flex items-center text-slate-400 hover:text-slate-600">
                <SafeIcon icon={field.show ? LuEyeOff : LuEye} className="w-4 h-4" />
              </button>
            </div>
          </div>
        ))}
        {error && <div className="bg-red-50 border border-red-200 text-red-700 text-sm px-4 py-3 rounded-xl">{error}</div>}
        {success && <div className="bg-emerald-50 border border-emerald-200 text-emerald-700 text-sm px-4 py-3 rounded-xl flex items-center gap-2"><SafeIcon icon={LuCheck} className="w-4 h-4" /> تم تغيير كلمة المرور بنجاح لهذه الجلسة!</div>}
        <button type="submit" className="w-full bg-emerald-600 hover:bg-emerald-700 text-white py-3 rounded-xl font-bold transition-colors flex items-center justify-center gap-2"><SafeIcon icon={LuLock} className="w-4 h-4" /> تغيير كلمة المرور</button>
      </form>
    </div>
  );
};

const AdminSiteSettings = () => {
  const [activeSubTab, setActiveSubTab] = useState('general');
  const [values, setValues] = useState(DEFAULT_VALUES);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [savedKey, setSavedKey] = useState(null);
  const [uploading, setUploading] = useState('');
  const logoRef = useRef(null);
  const faviconRef = useRef(null);

  useEffect(() => { fetchSettings(); }, []);

  const fetchSettings = async () => {
    setLoading(true);
    try {
      const { data } = await supabase.from('site_settings').select('setting_key, setting_value');
      if (data) {
        const mapped = { ...DEFAULT_VALUES };
        data.forEach(row => {
          if (row.setting_key in mapped) mapped[row.setting_key] = row.setting_value;
        });
        setValues(mapped);
      }
    } catch (err) { console.error(err); }
    finally { setLoading(false); }
  };

  const uploadFile = async (file, prefix) => {
    const ext = file.name.split('.').pop();
    const name = `${prefix}_${Date.now()}.${ext}`;
    const { error } = await supabase.storage.from(BUCKET).upload(name, file, { cacheControl: '3600', upsert: false });
    if (error) throw error;
    return supabase.storage.from(BUCKET).getPublicUrl(name).data.publicUrl;
  };

  const handleUpload = async (file, key, prefix) => {
    setUploading(key);
    try {
      const url = await uploadFile(file, prefix);
      setValues(p => ({ ...p, [key]: url }));
    } catch (err) { alert(`خطأ في الرفع: ${err.message}`); }
    finally { setUploading(''); }
  };

  const handleSaveAll = async () => {
    setSaving(true);
    try {
      const upserts = Object.entries(values).map(([setting_key, setting_value]) => ({ setting_key, setting_value }));
      const { error } = await supabase.from('site_settings').upsert(upserts, { onConflict: 'setting_key' });
      if (error) throw error;
      setSavedKey('all');
      setTimeout(() => setSavedKey(null), 2500);
    } catch (err) { alert(`خطأ: ${err.message}`); }
    finally { setSaving(false); }
  };

  const set = (key) => (e) => setValues(p => ({ ...p, [key]: e.target.value }));
  const setHtml = (key) => (content) => setValues(p => ({ ...p, [key]: content }));

  if (loading) return <div className="flex justify-center py-10"><div className="animate-spin rounded-full h-8 w-8 border-b-2 border-emerald-500" /></div>;

  const SaveBtn = () => (
    <button onClick={handleSaveAll} disabled={saving} className="flex items-center gap-2 px-5 py-2.5 bg-emerald-600 hover:bg-emerald-700 text-white rounded-xl text-sm font-bold disabled:opacity-60">
      {savedKey === 'all' ? <><SafeIcon icon={LuCheck} className="w-4 h-4" /> تم الحفظ!</> : <><SafeIcon icon={LuSave} className="w-4 h-4" /> حفظ الكل</>}
    </button>
  );

  return (
    <div className="bg-white rounded-2xl shadow-sm border border-slate-200 overflow-hidden">
      <div className="flex gap-1 p-4 border-b border-slate-100 bg-slate-50 flex-wrap">
        {SUBTABS.map(tab => (
          <button key={tab.id} onClick={() => setActiveSubTab(tab.id)} className={`flex items-center gap-2 px-4 py-2 rounded-xl text-sm font-bold transition-all ${activeSubTab === tab.id ? 'bg-white text-slate-900 shadow-sm border border-slate-200' : 'text-slate-500 hover:text-slate-700 hover:bg-white/60'}`}>
            <SafeIcon icon={tab.icon} className="w-4 h-4" /> {tab.label}
          </button>
        ))}
      </div>

      <div className="p-6">
        {activeSubTab === 'general' && (
          <div>
            <div className="flex justify-between items-center mb-6">
              <h2 className="text-lg font-bold text-slate-800">نصوص الصفحة الرئيسية</h2>
              <div className="flex gap-2">
                <button onClick={fetchSettings} className="flex items-center gap-1.5 px-3 py-2 text-slate-600 bg-slate-100 hover:bg-slate-200 rounded-xl text-sm font-medium"><SafeIcon icon={LuRefreshCw} className="w-4 h-4" /> تحديث</button>
                <SaveBtn />
              </div>
            </div>
            <div className="space-y-4">
              {[
                { key: 'calc_title', label: 'عنوان قسم الحاسبة', type: 'input' },
                { key: 'calc_subtitle', label: 'وصف قسم الحاسبة', type: 'textarea' },
                { key: 'cars_title', label: 'عنوان قسم السيارات', type: 'input' },
                { key: 'cars_subtitle', label: 'وصف قسم السيارات', type: 'textarea' },
              ].map(field => (
                <div key={field.key} className="bg-slate-50 rounded-xl p-4 border border-slate-200">
                  <label className="block text-sm font-bold text-slate-700 mb-2">{field.label}</label>
                  {field.type === 'textarea' ? <textarea value={values[field.key] || ''} onChange={set(field.key)} rows={2} className={inputCls + ' resize-none'} /> : <input type="text" value={values[field.key] || ''} onChange={set(field.key)} className={inputCls} />}
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Navbar & Footer Tabs remain unchanged... */}
        {activeSubTab === 'navbar' && (
           <div className="max-w-2xl">
           <div className="flex items-center justify-between gap-3 mb-6">
             <div className="flex items-center gap-3">
               <div className="w-10 h-10 bg-blue-100 rounded-xl flex items-center justify-center"><SafeIcon icon={LuLayoutTemplate} className="w-5 h-5 text-blue-600" /></div>
               <div><h2 className="text-lg font-bold text-slate-800">إعدادات شريط التنقل</h2><p className="text-xs text-slate-500">تخصيص اللوجو، الفيفيكون، والنافبار</p></div>
             </div>
             <SaveBtn />
           </div>
           <div className="mb-5 rounded-xl overflow-hidden border border-slate-200 shadow-sm">
             <div className="px-4 py-2 text-xs font-bold text-slate-500 bg-slate-100 flex items-center gap-1.5"><SafeIcon icon={LuEye} className="w-3.5 h-3.5" /> معاينة مباشرة</div>
             <div className="px-4 py-4 flex items-center justify-between" style={{ backgroundColor: values.navbar_bg_color, borderBottom: `1px solid ${values.navbar_accent_color}20` }}>
               <div className="flex items-center gap-3">
                 {values.navbar_logo_url ? <img src={values.navbar_logo_url} alt="logo" style={{ height: `${values.navbar_logo_size || 40}px`, objectFit: 'contain' }} onError={e => e.target.style.display = 'none'} /> : <div className="rounded-xl flex items-center justify-center" style={{ background: values.navbar_accent_color, height: `${values.navbar_logo_size || 40}px`, width: `${values.navbar_logo_size || 40}px` }}></div>}
                 {!values.navbar_logo_url && (
                   <div className="flex flex-col justify-center">
                     <div className="font-black text-sm leading-none mb-1" style={{ color: '#0f172a' }}>{values.navbar_site_name}</div>
                     <div className="text-xs font-bold leading-none" style={{ color: values.navbar_accent_color }}>{values.navbar_site_tagline}</div>
                   </div>
                 )}
               </div>
               <span className="text-xs font-bold px-3 py-1.5 rounded-lg" style={{ backgroundColor: `${values.navbar_accent_color}15`, color: values.navbar_accent_color }}>{values.navbar_home_label}</span>
             </div>
           </div>
           <div className="space-y-5">
             <div className="bg-slate-50 rounded-xl border border-slate-200 p-4">
               <label className="block text-sm font-bold text-slate-700 mb-3 flex items-center gap-1.5"><SafeIcon icon={LuImage} className="w-4 h-4 text-slate-500" /> اللوجو والحجم</label>
               <div className="flex gap-3 items-start mb-4">
                 <div className="w-20 h-16 bg-white rounded-xl border-2 border-dashed border-slate-300 flex items-center justify-center flex-shrink-0 overflow-hidden">
                   {values.navbar_logo_url ? <img src={values.navbar_logo_url} alt="logo" className="w-full h-full object-contain p-1" onError={e => e.target.style.display = 'none'} /> : <SafeIcon icon={LuImage} className="w-6 h-6 text-slate-300" />}
                 </div>
                 <div className="flex-1 space-y-2">
                   <button type="button" onClick={() => logoRef.current?.click()} disabled={uploading === 'navbar_logo_url'} className="flex items-center gap-2 px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-xl text-sm font-bold transition-colors disabled:opacity-60">
                     <SafeIcon icon={uploading === 'navbar_logo_url' ? LuX : LuUpload} className="w-4 h-4" />{uploading === 'navbar_logo_url' ? 'جاري الرفع...' : 'رفع صورة اللوجو'}
                   </button>
                   <input ref={logoRef} type="file" accept="image/*,image/svg+xml" className="hidden" onChange={e => e.target.files?.[0] && handleUpload(e.target.files[0], 'navbar_logo_url', 'logo')} />
                   <input type="url" value={values.navbar_logo_url} onChange={set('navbar_logo_url')} placeholder="أو الصق رابط الصورة..." dir="ltr" className="w-full p-2 border border-slate-200 rounded-lg text-xs bg-white focus:ring-2 focus:ring-blue-500 outline-none" />
                   {values.navbar_logo_url && <button type="button" onClick={() => setValues(p => ({ ...p, navbar_logo_url: '' }))} className="text-xs text-red-500 hover:text-red-700 flex items-center gap-1"><SafeIcon icon={LuX} className="w-3 h-3" /> إزالة اللوجو</button>}
                 </div>
               </div>
               <div className="pt-3 border-t border-slate-200">
                 <label className="block text-xs font-bold text-slate-600 mb-2 flex items-center gap-1"><SafeIcon icon={LuScaling} className="w-3.5 h-3.5" /> حجم اللوجو (الارتفاع بالبيكسل): <span className="text-blue-600">{values.navbar_logo_size || 40}px</span></label>
                 <input type="range" min="20" max="80" step="1" value={values.navbar_logo_size || 40} onChange={set('navbar_logo_size')} className="w-full h-2 bg-slate-200 rounded-lg appearance-none cursor-pointer accent-blue-600" />
               </div>
             </div>
             <div className="bg-slate-50 rounded-xl border border-slate-200 p-4">
               <label className="block text-sm font-bold text-slate-700 mb-3 flex items-center gap-1.5"><SafeIcon icon={LuGlobe} className="w-4 h-4 text-slate-500" /> أيقونة المتصفح (Favicon)</label>
               <div className="flex gap-3 items-start">
                 <div className="w-20 h-16 bg-white rounded-xl border-2 border-dashed border-slate-300 flex flex-col items-center justify-center flex-shrink-0 gap-1">
                   {values.site_favicon_url ? <img src={values.site_favicon_url} alt="favicon" className="w-8 h-8 object-contain" onError={e => e.target.style.display = 'none'} /> : <SafeIcon icon={LuGlobe} className="w-6 h-6 text-slate-300" />}
                 </div>
                 <div className="flex-1 space-y-2">
                   <button type="button" onClick={() => faviconRef.current?.click()} disabled={uploading === 'site_favicon_url'} className="flex items-center gap-2 px-4 py-2 bg-violet-600 hover:bg-violet-700 text-white rounded-xl text-sm font-bold transition-colors disabled:opacity-60">
                     <SafeIcon icon={uploading === 'site_favicon_url' ? LuX : LuUpload} className="w-4 h-4" />{uploading === 'site_favicon_url' ? 'جاري الرفع...' : 'رفع أيقونة المتصفح'}
                   </button>
                   <input ref={faviconRef} type="file" accept="image/*,.ico,.svg" className="hidden" onChange={e => e.target.files?.[0] && handleUpload(e.target.files[0], 'site_favicon_url', 'favicon')} />
                   <input type="url" value={values.site_favicon_url} onChange={set('site_favicon_url')} placeholder="أو الصق رابط الأيقونة..." dir="ltr" className="w-full p-2 border border-slate-200 rounded-lg text-xs bg-white focus:ring-2 focus:ring-violet-500 outline-none" />
                   {values.site_favicon_url && <button type="button" onClick={() => setValues(p => ({ ...p, site_favicon_url: '' }))} className="text-xs text-red-500 hover:text-red-700 flex items-center gap-1"><SafeIcon icon={LuX} className="w-3 h-3" /> إزالة الأيقونة</button>}
                 </div>
               </div>
             </div>
             <div className="grid grid-cols-2 gap-4">
               <div><label className="block text-sm font-bold text-slate-700 mb-1">اسم الموقع</label><input type="text" value={values.navbar_site_name} onChange={set('navbar_site_name')} className={inputCls} /></div>
               <div><label className="block text-sm font-bold text-slate-700 mb-1">الوصف تحت الاسم</label><input type="text" value={values.navbar_site_tagline} onChange={set('navbar_site_tagline')} className={inputCls} /></div>
             </div>
             <div><label className="block text-sm font-bold text-slate-700 mb-1">نص زر الرئيسية</label><input type="text" value={values.navbar_home_label} onChange={set('navbar_home_label')} className={inputCls} /></div>
             <div className="grid grid-cols-2 gap-4">
               {[['navbar_bg_color', 'لون الخلفية'], ['navbar_accent_color', 'اللون الرئيسي']].map(([k, l]) => (
                 <div key={k}><label className="block text-sm font-bold text-slate-700 mb-1">{l}</label><div className="flex gap-2 items-center"><input type="color" value={values[k]} onChange={set(k)} className="h-10 w-14 rounded-lg border border-slate-200 cursor-pointer p-1" /><input type="text" value={values[k]} onChange={set(k)} className={inputCls + ' flex-1'} dir="ltr" /></div></div>
               ))}
             </div>
           </div>
         </div>
        )}

        {activeSubTab === 'footer' && (
          <div className="max-w-lg">
          <div className="flex items-center justify-between gap-3 mb-6">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 bg-purple-100 rounded-xl flex items-center justify-center"><SafeIcon icon={LuHeart} className="w-5 h-5 text-purple-600" /></div>
              <div><h2 className="text-lg font-bold text-slate-800">إعدادات الفوتر</h2><p className="text-xs text-slate-500">تخصيص محتوى وألوان أسفل الموقع</p></div>
            </div>
            <SaveBtn />
          </div>
          <div className="mb-5 rounded-xl overflow-hidden border border-slate-200 shadow-sm">
            <div className="px-4 py-2 text-xs font-bold text-slate-500 bg-slate-100 flex items-center gap-1.5"><SafeIcon icon={LuEye} className="w-3.5 h-3.5" /> معاينة مباشرة</div>
            <div className="px-6 py-4 flex flex-col sm:flex-row items-center justify-between gap-3" style={{ backgroundColor: values.footer_bg_color, borderTop: '1px solid #e2e8f0' }}>
              <span className="font-black text-sm" style={{ color: '#0f172a' }}>{values.footer_site_name}</span>
              <span className="text-xs" style={{ color: values.footer_text_color }}>{values.footer_tagline}</span>
              <span className="text-xs" style={{ color: values.footer_text_color }}>{values.footer_copyright}</span>
            </div>
          </div>
          <div className="space-y-4">
            <div className="grid grid-cols-2 gap-4">
              <div><label className="block text-sm font-bold text-slate-700 mb-1">اسم الموقع في الفوتر</label><input type="text" value={values.footer_site_name} onChange={set('footer_site_name')} className={inputCls} /></div>
              <div><label className="block text-sm font-bold text-slate-700 mb-1">نص الوسط</label><input type="text" value={values.footer_tagline} onChange={set('footer_tagline')} className={inputCls} /></div>
            </div>
            <div><label className="block text-sm font-bold text-slate-700 mb-1">نص حقوق النشر</label><input type="text" value={values.footer_copyright} onChange={set('footer_copyright')} className={inputCls} /></div>
            <div className="grid grid-cols-2 gap-4">
              {[['footer_bg_color', 'لون خلفية الفوتر'], ['footer_text_color', 'لون النصوص']].map(([k, l]) => (
                <div key={k}><label className="block text-sm font-bold text-slate-700 mb-1">{l}</label><div className="flex gap-2 items-center"><input type="color" value={values[k]} onChange={set(k)} className="h-10 w-14 rounded-lg border border-slate-200 cursor-pointer p-1" /><input type="text" value={values[k]} onChange={set(k)} className={inputCls + ' flex-1'} dir="ltr" /></div></div>
              ))}
            </div>
          </div>
        </div>
        )}

        {activeSubTab === 'pages' && (
          <div className="max-w-4xl">
            <div className="flex items-center justify-between gap-3 mb-6">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 bg-teal-100 rounded-xl flex items-center justify-center"><SafeIcon icon={LuFileText} className="w-5 h-5 text-teal-600" /></div>
                <div><h2 className="text-lg font-bold text-slate-800">الصفحات الإضافية</h2><p className="text-xs text-slate-500">تعديل محتوى صفحات اتصل بنا ومن نحن (محرر متقدم)</p></div>
              </div>
              <SaveBtn />
            </div>
            
            <div className="space-y-8">
              <div className="bg-slate-50 rounded-xl border border-slate-200 p-5">
                <label className="block text-sm font-bold text-slate-700 mb-2">صفحة "من نحن"</label>
                <p className="text-xs text-slate-500 mb-3">يمكنك إضافة صور، فيديوهات، وتنسيق الخط كما تشاء. سيظهر في صفحة /about</p>
                <ReactQuill 
                  theme="snow" 
                  value={values.page_about_us || ''} 
                  onChange={setHtml('page_about_us')}
                  modules={quillModules}
                  formats={quillFormats}
                  className="bg-white rounded-xl overflow-hidden"
                />
              </div>

              <div className="bg-slate-50 rounded-xl border border-slate-200 p-5">
                <label className="block text-sm font-bold text-slate-700 mb-2">صفحة "اتصل بنا"</label>
                <p className="text-xs text-slate-500 mb-3">ضع معلومات التواصل الخاصة بك (أرقام الجوال، الإيميل، العنوان، خرائط جوجل). ستظهر في صفحة /contact</p>
                <ReactQuill 
                  theme="snow" 
                  value={values.page_contact_us || ''} 
                  onChange={setHtml('page_contact_us')}
                  modules={quillModules}
                  formats={quillFormats}
                  className="bg-white rounded-xl overflow-hidden"
                />
              </div>
            </div>
          </div>
        )}

        {activeSubTab === 'affiliate' && (
          <div className="max-w-4xl">
            <div className="flex items-center justify-between gap-3 mb-6">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 bg-indigo-100 rounded-xl flex items-center justify-center"><SafeIcon icon={LuUsers} className="w-5 h-5 text-indigo-600" /></div>
                <div><h2 className="text-lg font-bold text-slate-800">إعدادات التسويق بالعمولة</h2><p className="text-xs text-slate-500">التحكم في التسجيل والشروط</p></div>
              </div>
              <SaveBtn />
            </div>
            <div className="space-y-6">
              <div className="bg-slate-50 rounded-xl border border-slate-200 p-5">
                <h3 className="text-sm font-bold text-slate-800 mb-4 flex items-center gap-2"><SafeIcon icon={LuType} className="w-4 h-4 text-indigo-500"/> نصوص صفحة التسجيل</h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                  <div>
                    <label className="block text-xs font-bold text-slate-700 mb-1">عنوان الفورم</label>
                    <input type="text" value={values.affiliate_reg_title || ''} onChange={set('affiliate_reg_title')} className={inputCls} placeholder="إنشاء حساب مسوق" />
                  </div>
                  <div>
                    <label className="block text-xs font-bold text-slate-700 mb-1">وصف الفورم</label>
                    <input type="text" value={values.affiliate_reg_subtitle || ''} onChange={set('affiliate_reg_subtitle')} className={inputCls} placeholder="أدخل بياناتك لإنشاء حسابك..." />
                  </div>
                </div>
              </div>

              <div className="bg-slate-50 rounded-xl border border-slate-200 p-5">
                <label className="flex items-center gap-3 cursor-pointer">
                  <div className="relative">
                    <input type="checkbox" className="sr-only" checked={values.affiliate_reg_open === 'true'} onChange={(e) => setValues(p => ({ ...p, affiliate_reg_open: e.target.checked ? 'true' : 'false' }))} />
                    <div className={`block w-14 h-8 rounded-full transition-colors ${values.affiliate_reg_open === 'true' ? 'bg-indigo-500' : 'bg-slate-300'}`}></div>
                    <div className={`absolute left-1 top-1 bg-white w-6 h-6 rounded-full transition-transform ${values.affiliate_reg_open === 'true' ? 'transform translate-x-6' : ''}`}></div>
                  </div>
                  <div>
                    <span className="font-bold text-slate-800 block">فتح باب التسجيل للمسوقين</span>
                    <span className="text-xs text-slate-500">عند الإغلاق، لن يتمكن مسوقون جدد من التسجيل</span>
                  </div>
                </label>
              </div>
              
              <div className="bg-slate-50 rounded-xl border border-slate-200 p-5">
                <label className="block text-sm font-bold text-slate-700 mb-2">شروط وقوانين التسويق بالعمولة (محرر متقدم)</label>
                <p className="text-xs text-slate-500 mb-3">هذه الشروط ستظهر للمسوق قبل التسجيل ويجب عليه الموافقة عليها.</p>
                <ReactQuill 
                  theme="snow" 
                  value={values.affiliate_terms || ''} 
                  onChange={setHtml('affiliate_terms')}
                  modules={quillModules}
                  formats={quillFormats}
                  className="bg-white rounded-xl overflow-hidden"
                />
              </div>
            </div>
          </div>
        )}

        {activeSubTab === 'password' && <AdminPasswordChange />}
      </div>
    </div>
  );
};

export default AdminSiteSettings;